
<div mdbModal role="dialog" min-width="95%" >
  <div class="modal-body" [style.--audit-modal-max-height.px]="auditModalMaxHeight">
    <div class="container-fluid">
        <div *ngIf="isauditLoading === true" class="fade show" style="text-align: center; height: 30px">
          <i class="spinner-grow spinner-grow-sm"></i>
          <span class="ms-2">Loading quote logs, please wait!</span>
        </div>
        <ng-container [style.display]="isauditLoading === false ? 'block' : 'none'">
          <div class="audit-grid-wrap">
            <lms-table-wrapper [config]="config" (changePaged)="setPage($event)">
              <table class="table table-sm audit-trail-grid">
                <colgroup>
                  <col class="audit-col-first" />
                  <col class="audit-col-data" />
                  <col class="audit-col-data" />
                </colgroup>
                <thead>
                  <tr class="table-center-header">
                    <th *ngFor="let column of table_config.columns" [hidden]="column.hideCol" [class.numeric-col]="column.numeric">{{column.heading}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let table_row of table_data_source | paginate: config; let i = index">
                    <td *ngFor="let column of table_config.columns" [hidden]="column.hideCol" [class.numeric-col]="column.numeric"
                      [class.dataval-col]="column.key === 'newData' || column.key === 'previousData'"
                      [class.date-col]="column.datecol">

                    <ng-container *ngIf="column.datecol">
                      <figure>
                        <blockquote class="blockquote lh-sm">
                          <p class="mb-1 text-muted">{{table_row[column.key] | date: 'yyyy-MM-dd HH:mm:ss'}}</p>
                          <h6 class="mb-1 text-end">{{table_row['action']}}</h6>
                        </blockquote>
                        <figcaption class="blockquote-footer pt-2">
                          <cite title="Actioning User">{{table_row['userName']}}</cite>
                        </figcaption>
                      </figure>
                    </ng-container>

                    <ng-container *ngIf="column.key === 'newData'">
                      <div class="note note-success opacity-95 audit-note">
                        <strong class="text-success text-start"><i class="fas fas fa-circle-check me-2"></i> New: </strong>
                        <div class="ps-3 text-break text-start lh-sm audit-val">{{table_row[column.key]}}</div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="column.key === 'previousData'">
                      <div class="note opacity-75 audit-note" [ngClass]="table_row[column.key] ? 'note-danger' : 'note-light audit-note-empty'">
                        <strong class="text-danger"
                          [ngClass]="{'text-decoration-line-through': !table_row[column.key]}"><i
                            class="fas fa-circle-xmark me-2"></i> Previous: </strong>
                        <div class="ps-1 text-break text-start audit-val lh-sm">{{table_row[column.key] || 'No previous value'}}</div>
                      </div>
                    </ng-container>
                    </td>
                  </tr>
                </tbody>
              </table>
            </lms-table-wrapper>
          </div>
        </ng-container>
    </div>
  </div>
  <!-- <div class="modal-footer flex-container">
    <button class="btn btn-primary" mdbRipple (click)="dialogRef.close()"> Close </button>
  </div> -->
</div>
